import { Schema } from 'effect';

export const VersionSchema = Schema.transform(
  Schema.Struct({
    release_version: Schema.String,
    backend_version: Schema.String
  }),
  Schema.Struct({
    releaseVersion: Schema.String,
    backendVersion: Schema.String
  }),
  {
    strict: true,
    decode: (api) => ({
      releaseVersion: api.release_version,
      backendVersion: api.backend_version
    }),
    encode: (client) => ({
      release_version: client.releaseVersion,
      backend_version: client.backendVersion
    })
  }
);
export type Version = Schema.Schema.Type<typeof VersionSchema>;
